/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface AssetEventOffsetUSMarker {
  size?: number,
  arrowColor?: string,
  fillColor?: string,
  opacity?: number,
  version2?: boolean
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic with Offset for moving events of the asset
 *
 * ```typescript
 *  import {getAssetEventOffsetUSMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getAssetEventOffsetUSMarker({size, outlineColor, fillColor}),
 *    width  : size,
 *    height : size,
 *    angle  : angle - 90
 * }
 * ```
 */
export const getAssetEventOffsetUSMarker = ({
  fillColor = dlsColor('grey4'),
  arrowColor = dlsColor('white'),
  size = 30,
  opacity = 1
}: AssetEventOffsetUSMarker) => {
  const svg = (`
    <svg width='${size}' height='${size}' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M36 13.2C30.0353 13.2 25.2 18.0353 25.2 24C25.2 29.9647 30.0353 34.8 36 34.8C41.9647 34.8 46.8 29.9647 46.8 24C46.7934 18.0381 41.9619 13.2066 36 13.2Z' fill='${arrowColor}'/>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M36 33C31.0294 33 27 28.9706 27 24C27 19.0294 31.0294 15 36 15C40.9706 15 45 19.0294 45 24C44.9944 28.9683 40.9683 32.9944 36 33Z' fill='${fillColor}' opacity='${opacity}' stroke='white'/>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M36 16L30 29.5L36 26.5L42 29.5L36 16Z' fill='${arrowColor}'/>
    </svg>
  `);

  return convertSvgToDataUri(svg.trim());
};

export default getAssetEventOffsetUSMarker;
